import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    code: "",
    isHuri: false
};

const promoCodeSlice = createSlice({
    name: "promoCode",
    initialState,
    reducers: {
        promoCodeAdded(state, action) {
            state.code = action.payload;
        },
        isHuriAdded(state, action) {
            state.isHuri = action.payload;
        }
    }
});

export const promoCodeSelector = (state) => state.promoCode;

export const { promoCodeAdded, isHuriAdded } = promoCodeSlice.actions;
export default promoCodeSlice.reducer;